import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { ContactModalProvider } from "./context/ContactModalContext";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AIRealitySection from "./components/AIRealitySection";
import AdvantageSection from "./components/AdvantageSection";
import TestimonialSection from "./components/TestimonialSection";
import IntegrationsSection from "./components/IntegrationsSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import ContactModal from "./components/ContactModal";
import { useContactModal } from "./context/ContactModalContext";
import AboutPage from "./pages/AboutPage";
import {
  TemporaryPage,
  RecruitmentPage,
  ConsultingPage,
} from "./pages/ServicePages";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <AIRealitySection />
      <AdvantageSection />
      <IntegrationsSection />
      <TestimonialSection />
      <CTASection />
      <Footer />
    </div>
  );
};

const AppContent = () => {
  const { isContactModalOpen, closeContactModal } = useContactModal();

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          {/* Service pages */}
          <Route path="/temporary" element={<TemporaryPage />} />
          <Route path="/recruitment" element={<RecruitmentPage />} />
          <Route path="/consulting" element={<ConsultingPage />} />
        </Routes>
      </BrowserRouter>
      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} />
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <ContactModalProvider>
        <div className="App">
          <AppContent />
        </div>
      </ContactModalProvider>
    </LanguageProvider>
  );
}

export default App;
